import type {
  IPhotoInteractionEvent,
  IPhotoInteractionInput,
} from '../types/clickEvents';

const photoInteraction = (
  input: IPhotoInteractionInput,
): Omit<IPhotoInteractionEvent, 'event'> => ({
  input: input.input,
});

export default photoInteraction;
